import { CircularProgress, TextField } from '@material-ui/core';
import * as moment from 'moment';
import * as React from 'react';

import { ClientUpdateData } from '../state';
import { WeeklyUpdateJobSectionComponent } from './weekly-update-job-section';

interface WeeklyUpdateEmailProps {
    data: ClientUpdateData;
    startDate: number;
    endDate: number;
    inProgress: boolean;
    onDateChange: (startDate: number) => void;
}

const containerStyle = {
    background: '#fff',
    flex: '1 1 auto',
    overflowY: 'scroll' as any,
    padding: '10px'
};

const mainStyle = {
    color: '#212121',
    fontFamily: 'Arial',
    fontSize: '13px',
    lineHeight: '1.7'
};

const configStyle = {
    background: '#ddd',
    padding: '0px 10px'
};

export class WeeklyUpdateEmailComponent extends React.Component<WeeklyUpdateEmailProps, undefined> {
    constructor(props: WeeklyUpdateEmailProps) {
        super(props);
    }

    handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = moment(event.target.value, 'YYYY-MM-DD').valueOf();
        this.props.onDateChange(newDate);
    };

    render() {
        const { data, startDate, endDate } = this.props;

        const jobsSections = data
            ? data.jobs.map((jobAndCandidate) => {
                  const stageCounts = this.props.data.jobStageCounts[jobAndCandidate.job.id] || {};

                  return (
                      <WeeklyUpdateJobSectionComponent
                          jobAndCandidates={jobAndCandidate}
                          stageCounts={stageCounts}
                          startDate={this.props.startDate}
                          endDate={this.props.endDate}
                          clientName={data.client.name}
                          key={jobAndCandidate.job.id}
                      />
                  );
              })
            : null;

        const startDateInputProps = { max: moment(endDate).format('YYYY-MM-DD') };
        const inputLabelProps = { shrink: true };

        const content = data ? (
            <div>
                <div style={configStyle}>
                    <div>
                        <TextField
                            label="Start Date"
                            type="date"
                            value={moment(startDate).format('YYYY-MM-DD')}
                            onChange={this.handleDateChange}
                            inputProps={startDateInputProps}
                            InputLabelProps={inputLabelProps}
                            style={{ marginRight: '20px' }}
                        />
                        <TextField
                            label="End Date"
                            type="date"
                            value={moment(endDate).format('YYYY-MM-DD')}
                            disabled={true}
                            InputLabelProps={inputLabelProps}
                        />
                    </div>
                </div>
                <div>
                    <h2>
                        Rocket Hiring Update for {data.client.name} ({moment(endDate).format('MM/DD/YY')})
                    </h2>
                </div>
                <hr />
                <div style={mainStyle}>
                    <div>
                        This is an automated update, however please reply with any questions or feedback and we will
                        respond back.
                    </div>
                    <hr />
                    {jobsSections}
                </div>
            </div>
        ) : null;

        return (
            <div style={containerStyle}>
                <div
                    className="spinner-container"
                    style={{ display: !data || this.props.inProgress ? 'block' : 'none' }}
                >
                    <CircularProgress />
                </div>
                {content}
            </div>
        );
    }
}
